module.exports = __webpack_public_path__ + "static/media/cta-bg.08a7513b.png";